import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AttempAssesmentQuiztItem } from '@edtech-ui/core/models/admin-quiz-enhancement/get-quiz-assesment-attempt-link';
import { QuizManagementService } from '@edtech-ui/core/services/quiz-management/quiz-management.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, of, Subscription, tap } from 'rxjs';

@Component({
	selector: 'app-assesment-attempt-detail-page',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './assesment-attempt-detail-page.component.html',
	styleUrl: './assesment-attempt-detail-page.component.scss'
})
export class AssesmentAttemptDetailPageComponent implements OnInit, OnDestroy {

	linkId!: string;
	subscription = new Subscription();
	assessmentData: AttempAssesmentQuiztItem[] = [];
	invitedEmails: string[] = [];
	quizName = '';
	linkName = '';
	totalAttempt = 0
	passedAttempt = 0
	failedAttempt = 0
	avgScore = ''
	searchText = '';
	selectedTab: 'ALL' | 'PASSED' | 'FAILED' = 'ALL';
	searchTimeout: any;
	filteredData: any[] = [];
	quizId = '';



	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private toastr: ToastrService,
		private quizService: QuizManagementService
	) {

	}


	ngOnInit(): void {
		this.route.paramMap.subscribe(paramMap => {
			const id = paramMap.get('linkId');

			if (!id) return;

			this.linkId = id;
			if (this.linkId) {
				this.getAssesmentDetailPage();
				this.getQuizAssesmentById();
			}
		});
	}


	setTab(tab: 'ALL' | 'PASSED' | 'FAILED') {
		this.selectedTab = tab;
		this.getAssesmentDetailPage();
	}


	onSearch(value: string) {
		this.searchText = value;
		this.getAssesmentDetailPage();
	}


	applyFilter() {
		let data = [...this.assessmentData];

		if (this.selectedTab !== 'ALL') {
			data = data.filter(item =>
				item.result?.toLowerCase() === this.selectedTab.toLowerCase()
			);
		}

		if (this.searchText) {
			const search = this.searchText.toLowerCase();

			data = data.filter(item =>
				item.candidate_name?.toLowerCase().includes(search) ||
				item.candidate_email?.toLowerCase().includes(search)
			);
		}

		this.filteredData = data;
	}


	getAssesmentDetailPage() {
		let status = '';

		if (this.selectedTab === 'PASSED') {
			status = 'passed';
		}
		else if (this.selectedTab === 'FAILED') {
			status = 'failed';
		}

		this.subscription.add(
			this.quizService.getAssessmentGetLinkAttempts(
				this.linkId,
				status,
				undefined).pipe(
					tap(response => {
						if (response.Success) {
							this.totalAttempt = response.Data.total_attempts;
							this.passedAttempt = response.Data.passed;
							this.failedAttempt = response.Data.failed;
							this.avgScore = response.Data.avg_score;
							this.assessmentData = response.Data.attempts ?? [];
							if (this.assessmentData[0]?.quiz_id) {
								this.quizId = this.assessmentData[0].quiz_id;
							}
							this.applyMergedData();
						}
					})
				)
				.subscribe()
		);
	}

	loadInvitedCandidates() {
		if (!this.quizId || !this.linkId) return;
		this.subscription.add(
			this.quizService.getAllGenerateLinks(this.quizId, 1, 100).pipe(
				tap(response => {
					if (response.Success) {
						const currentLink = response.Data.data.find((l: any) => l.link_id === this.linkId);
						const invitedEmails = currentLink?.invited_emails || [];
						this.mergeInvitedCandidates(invitedEmails);
					}
				}),
				catchError(() => {
					return of(null);
				})
			).subscribe()
		);
	}

	mergeInvitedCandidates(invitedEmails: string[]) {
		this.invitedEmails = invitedEmails;
		this.applyMergedData();
	}

	applyMergedData() {
		let merged = [...this.assessmentData];
		const attemptedEmails = new Set(this.assessmentData.map(a => a.candidate_email?.toLowerCase()));
		const invitedOnly = this.invitedEmails.filter(email => !attemptedEmails.has(email.toLowerCase()));

		const virtualAttempts: any[] = invitedOnly.map(email => ({
			attempt_id: '',
			candidate_name: email.split('@')[0],
			candidate_email: email,
			score: null,
			score_percentage: '—',
			result: 'Invited',
			violations: 0,
			completed_at: null,
			quiz_id: this.quizId,
			attempt_number: 0,
			attempt_count: 0
		}));

		if (this.selectedTab === 'ALL') {
			merged = [...merged, ...virtualAttempts];
		}

		if (this.searchText) {
			const search = this.searchText.toLowerCase();
			merged = merged.filter(item =>
				item.candidate_name?.toLowerCase().includes(search) ||
				item.candidate_email?.toLowerCase().includes(search)
			);
		}

		this.filteredData = merged;
	}

	getQuizAssesmentById() {
		if (!this.linkId) return;
		this.subscription.add(
			this.quizService.getAssesmentById(this.linkId).pipe(
				tap(response => {
					if (response.Success) {
						this.quizName = response.Data.quiz_name;
						this.linkName = response.Data.link_name;
						this.quizId = response.Data.quiz_id;
						this.loadInvitedCandidates();
					}
				}),
				catchError(() => {
					this.toastr.error('Something went wrong');
					return of(null);
				})
			).subscribe()
		);
	}


	// goToAssessmentReportPage(attemptId: string) {
	// 	this.router.navigate(['admin-student-platform/assesment-report', attemptId])
	// }


	goToAssessmentReportPage(attemptId: string) {
		this.router.navigate(['assesment-report', attemptId])
	}

	goToLinkPages() {
		this.router.navigate(['admin-student-platform/view-links', this.quizId])
	}



	downloadViolations() {
		this.quizService.downloadViolations(this.linkId).subscribe((response: any) => {

			const blob = new Blob([response.body], { type: 'text/csv' });

			let fileName = 'violations.csv';

			const contentDisposition = response.headers.get('content-disposition');
			if (contentDisposition) {
				const match = contentDisposition.match(/filename="?(.+)"?/);
				if (match) fileName = match[1];
			}

			const url = window.URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.href = url;
			a.download = fileName;
			a.click();

			window.URL.revokeObjectURL(url);
		});
	}



	ngOnDestroy(): void {

	}

}
